export function buildEmailFormData(
  alarmId: number | string,
  payload: {
    to: string[];
    bcc: string[];
    subject: string;
    body: string;
    attachments: File[];
  }
): FormData {
  const fd = new FormData();
  fd.append('alarm_id', String(alarmId));
  fd.append('to', JSON.stringify(payload.to));
  fd.append('bcc', JSON.stringify(payload.bcc));
  fd.append('subject', payload.subject);
  fd.append('body', payload.body);
  payload.attachments.forEach((file) => fd.append('attachments', file));
  return fd;
}

export function buildReportEmailBody(
  site: string | null,
  startTime: string,
  description: string,
  senderName?: string | null
): string {
  return `Hello,

On ${startTime} at ${site || ''}, ${description}

For more details, please refer to the attached report document.
This mailbox is not monitored. Please do not reply to this email. If you have any questions or concerns, feel free to reply to cs@hakimo.ai. A member of our Customer Success team will be happy to assist you.

Thank you and stay safe.

${senderName ? `${senderName}\n` : ''}Hakimo Support
+1 669.242.5466  |  hakimo.ai`;
}
